"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../constants");
const normalizeStyleProps = props => Object.keys(props).filter(key => _constants.allowedStylesProps.includes(key)).reduce((acc, key) => {
  const styleKey = key.startsWith('$') ? key.slice(1, key.length) : key;
  return {
    ...acc,
    [styleKey]: props[key]
  };
}, {});
const Box = exports.Box = _styledComponents.default.div.withConfig({
  displayName: "styles__Box",
  componentId: "sc-s8e19u-0"
})(["", ""], normalizeStyleProps);